module.exports = __webpack_public_path__ + "static/media/class_job_029.358ebe49.svg";